import { gql } from "@apollo/client";

const GENERATE_SHIPPING_LABEL = gql`
  mutation generateLakeShippingLabel($input: ShippingLabelInput!) {
    generateLakeShippingLabel(input: $input) {
      status
      data
      error
    }
  }
`;

export default GENERATE_SHIPPING_LABEL;
